import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Image, Divider, Message } from "semantic-ui-react";
import { ResetPasswordForm } from "../../../components/Admin/Auth";
import { useLanguage } from "../../../contexts";
import logoImg from "../../../assets/svg/isosustemia 1.svg";
import { User } from "../../../api";
import "../Auth/Auth.scss";

const userController = new User();

export default function Reset() {
  const [userByToken, setUserByToken] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [langOpen, setLangOpen] = useState(false);
  const navigate = useNavigate();
  const { changeLanguage, translations, language } = useLanguage();
  const t = (key) => translations[key] || key;

  const urlparams = useLocation().pathname.split("/").filter((item) => item);

  useEffect(() => {
    if (!localStorage.getItem("appLanguage")) {
      const idiomaNavegador = navigator.language || navigator.userLanguage;
      const idioma = idiomaNavegador.split("-")[0];
      changeLanguage(["es", "en", "pt", "fr"].includes(idioma) ? idioma : "en");
    }
  }, []);

  useEffect(() => {
    if (!isValid) {
      userController.getUserByResetTokenApi(urlparams[1]).then((response) => {
        setUserByToken(response.user);
        setIsLoading(false);
      }).catch(() => setIsLoading(false));
      setIsValid(true);
    }
  }, []);

  const renderModalContent = () => {
    if (isLoading) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <div className="ui active centered inline loader" />
        </div>
      );
    }

    if (!userByToken) {
      return (
        <div style={{ padding: "2rem" }}>
          <Message negative>
            <Message.Header>Enlace inválido</Message.Header>
            <p>El tiempo de restablecimiento de contraseña ha caducado o el token es inválido.</p>
          </Message>
        </div>
      );
    }

    return (
      <div className="login-modal-form">
        <ResetPasswordForm userByToken={userByToken} />
      </div>
    );
  };

  return (
    <div className="landing-page">
      {/* Navbar */}
      <nav className="landing-nav">
        <div className="landing-nav__left">
          <Image src={logoImg} className="landing-nav__logo-img" />
          <span className="landing-nav__brand">sustemia</span>
        </div>
        <div className="landing-nav__right">
          <div
            className={`landing-nav__lang-selector${langOpen ? " open" : ""}`}
            onMouseEnter={() => setLangOpen(true)}
            onMouseLeave={() => setLangOpen(false)}
          >
            {langOpen
              ? ["es", "en", "pt"].map((lang) => (
                  <span
                    key={lang}
                    className={`landing-nav__lang-opt${language === lang ? " active" : ""}`}
                    onClick={() => {
                      changeLanguage(lang);
                      setLangOpen(false);
                    }}
                  >
                    {lang.toUpperCase()}
                  </span>
                ))
              : (
                  <span
                    className="landing-nav__lang-opt active"
                    onClick={() => setLangOpen(true)}
                  >
                    {(language || "es").toUpperCase()}
                  </span>
                )}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <main className="landing-hero">
        <div className="landing-hero__card">
          <div className="landing-hero__bg-card" />
          <div className="landing-hero__inner-card">
            <h1 className="landing-hero__title">{t("platform_tagline")}</h1>
            <Divider className="landing-hero__divider" />
          </div>
        </div>
      </main>

      {/* Reset Password Modal */}
      <Modal
        open
        onClose={() => navigate("/admin")}
        size="tiny"
        closeIcon
        className="auth-modal"
      >
        <Modal.Content>
          {renderModalContent()}
        </Modal.Content>
      </Modal>
    </div>
  );
}
